import { render } from "./PonTree.vue?vue&type=template&id=33842614&scoped=true"
import script from "./PonTree.vue?vue&type=script&lang=js"
export * from "./PonTree.vue?vue&type=script&lang=js"

import "./PonTree.vue?vue&type=style&index=0&id=33842614&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33842614"]])

export default __exports__